import api from '../../services/api';

const urlBase = '/motoristas';

export default {
  listar: (params = {}) =>
    api.get(urlBase, { params }),

  criar: data =>
    api.post(urlBase, data),

  atualizar: (motoristaId, data) =>
    api.put(`${urlBase}/${motoristaId}`, data),

  mudarStatus: motoristaId =>
    api.put(`${urlBase}/mudar-status/${motoristaId}`),

  excluir: motoristaId =>
    api.delete(`${urlBase}/${motoristaId}`),

  uploadDocumento: (motoristaId, tipo, formData) =>
    api.post(`${urlBase}/${motoristaId}/documentos/${tipo}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
